import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { InfoOutlineIcon } from '@app-velocity/icons';

import { Tooltip } from '../../../Tooltip';
import { Label } from '../Label';

const StyledLabelRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  flex: 1,
}));

const StyledInfoIcon = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'help',
  marginBottom: theme.spacing(1),
  svg: {
    display: 'flex',
    width: theme.spacing(4),
    height: theme.spacing(4),
    fill: 'var(--text-text-secondary-color)',
  },
}));

export type LabelWithTooltipProps = {
  children: ReactNode;
  tooltip: ReactNode;
  className?: string;
  inline?: boolean;
};

export const LabelWithTooltip = ({
  children,
  tooltip,
  className,
  inline,
}: LabelWithTooltipProps) => {
  return (
    <StyledLabelRow className={className}>
      <Label>{children}</Label>
      <Tooltip title={tooltip} slotProps={{ popper: { disablePortal: true } }}>
        <StyledInfoIcon onClick={(event) => event.stopPropagation()}>
          <InfoOutlineIcon />
        </StyledInfoIcon>
      </Tooltip>
    </StyledLabelRow>
  );
};
